import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GeofenceService } from "../../services/GeofenceService";

export const useGeofences = (orgId) => {
  return useQuery({
    queryKey: ["geofences", orgId],
    queryFn: () => GeofenceService.fetchGeofences(orgId),
    enabled: !!orgId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useGeofence = (geofenceId) => {
  return useQuery({
    queryKey: ["geofence", geofenceId],
    queryFn: () => GeofenceService.fetchGeofence(geofenceId),
    enabled: !!geofenceId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateGeofence = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: GeofenceService.createGeofence,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["geofences", variables.orgId],
      });
    },
  });
};

export const useUpdateGeofence = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ geofenceId, data }) =>
      GeofenceService.updateGeofence(geofenceId, data),
    onSuccess: (_, { geofenceId, data }) => {
      queryClient.invalidateQueries({ queryKey: ["geofence", geofenceId] });
      queryClient.invalidateQueries({ queryKey: ["geofences", data.orgId] });
    },
  });
};

export const useDeleteGeofence = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ geofenceId }) => GeofenceService.deleteGeofence(geofenceId),
    onSuccess: (_, { geofenceId, orgId }) => {
      queryClient.invalidateQueries({ queryKey: ["geofences", orgId] });
      queryClient.removeQueries({ queryKey: ["geofence", geofenceId] });
    },
  });
};

export const useUpdateGeofenceStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ geofenceId, status }) =>
      GeofenceService.updateGeofenceStatus(geofenceId, status),
    onSuccess: (_, { orgId }) => {
      queryClient.invalidateQueries({ queryKey: ["geofences", orgId] });
    },
  });
};
